"use client";

import React from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import flatInfo from '../data/FlatInfo';

const centerMap = { lat: 23.8103, lng: 90.4125 }; // Dhaka, Bangladesh

const GMap = ({ onSelectFlat, mapCenter }) => {

  const customMarkerIcon = {
    url: "/marker.svg", 
    scaledSize: new window.google.maps.Size(40, 40),
  };



  return (
    <div style={{ width: "100%", height: "100%" }}>

    <GoogleMap
      center={mapCenter}
      zoom={14}
      mapContainerStyle={{ width: "100%", height: "100%", minHeight: "100%" }}
      >
      {flatInfo.map((flat) => (
        <Marker 
        key={flat.id} 
        position={{ lat: flat.latitude, lng: flat.longitude }} 
        title={flat.title} 
        onClick={() => onSelectFlat(flat)}
        icon={customMarkerIcon}
        />
      ))}
    </GoogleMap>
  </div>
  );
};

export default GMap;